export default __webpack_public_path__ + "static/media/store_svg7.b2b97b55.svg";